import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import isPageLoadedInIframe from '../../../utils/surveyEmbedding/isPageLoadedInIframe';
import StylingToCSSButton from '../../../domains/styling/hocs/StylingToCSS/StylingToCSSButton';

import styles from './ButtonContentView.scss';

const ButtonContentView = ({
  e2e,
  block: { alignment: textAlign, label, url },
  buttonCSS,
  inputCSS,
  readOnly,
  onClick,
}) => (
  <div style={{ textAlign }}>
    <a
      href={readOnly ? null : url}
      className={readOnly ? styles.button : styles.buttonClient}
      style={{
        ...buttonCSS,
        ...inputCSS,
      }}
      onClick={onClick}
      data-e2e={e2e}
      target={isPageLoadedInIframe() ? '_blank' : '_self'}
    >
      {label}
    </a>
  </div>
);

ButtonContentView.defaultProps = {
  e2e: 'taker-btn',
  onClick: noop,
};

ButtonContentView.propTypes = {
  block: PropTypes.shape({
    alignment: PropTypes.string,
    label: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
  buttonCSS: PropTypes.object,
  inputCSS: PropTypes.object,
  e2e: PropTypes.string,
  onClick: PropTypes.func,
  readOnly: PropTypes.bool,
};

export default StylingToCSSButton(ButtonContentView);
